"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAuthInterceptor = exports.processMultiLanguageProps = void 0;
const appConfig_1 = require("./common/utils/appConfig");
const global_1 = require("./store/global");
const processMultiLanguageProps = (registerConfig) => {
    const banner = registerConfig.subApps.find(item => item.alias === 'banner');
    if (banner) {
        banner.props = Object.assign(Object.assign({}, banner.props), { multiLanguageSubUrl: (0, appConfig_1.getConfig)().bannerMultiLanguageSubUrl });
    }
    const login = registerConfig.subApps.find(item => item.alias === 'login');
    if (login) {
        login.props = Object.assign(Object.assign({}, login.props), { multiLanguageSubUrl: (0, appConfig_1.getConfig)().loginMultiLanguageSubUrl });
    }
    const footer = registerConfig.subApps.find(item => item.alias === 'footer');
    if (footer) {
        footer.props = Object.assign(Object.assign({}, footer.props), { multiLanguageSubUrl: (0, appConfig_1.getConfig)().footerMultiLanguageSubUrl });
    }
};
exports.processMultiLanguageProps = processMultiLanguageProps;
const getPathnameWithoutPrefix = ({ registerConfig, history }) => {
    const { publicPath } = registerConfig.stitcher; // "" or "/digital/web/hk/bfo-t1", configed in register-config.json
    console.log('stitcher - getPathnameWithoutPrefix, publicPath:', publicPath);
    const { pathname } = history.location;
    console.log('stitcher - getPathnameWithoutPrefix, pathname:', pathname); // will always start with "/"
    let urlTojudge = pathname.replace(publicPath, ''); // not always start with "/", may end with "/" or not
    urlTojudge = urlTojudge === '' ? '/' : urlTojudge;
    console.log('stitcher - getPathnameWithoutPrefix, urlTojudge:', urlTojudge);
    return urlTojudge;
};
const isLogin = () => (0, global_1.getAccessToken)();
const checkAuthInterceptor = ({ registerConfig, history, app, loginURL, landingApp }) => {
    const { publicPath, mainPublicPath } = registerConfig.stitcher; // "" or "/digital/web/hk/bfo-t1", configed in register-config.json
    const { pathname } = history.location;
    console.log('stitcher - checkAuthInterceptor, pathname:', pathname); // will always start with "/"
    const urlTojudge = getPathnameWithoutPrefix({ registerConfig, history });
    if (app.alias && typeof app.alias === 'string' && app.alias.length > 0) {
        if (app.alias === 'login') {
            const isLoginVar = isLogin();
            if (app.configuration.loginRequired) {
                if (isLoginVar) {
                    if (urlTojudge === `${mainPublicPath}/login` || urlTojudge === `${mainPublicPath}/login/`) {
                        history.push(`${publicPath}${mainPublicPath}/home`);
                        return false;
                    }
                }
                else {
                    if (urlTojudge === `${mainPublicPath}/logout` || urlTojudge === `${mainPublicPath}/logoutError` || urlTojudge === `${mainPublicPath}/companyRedirect`) {
                        return true;
                    }
                    if (urlTojudge !== `${mainPublicPath}/login`) {
                        history.push(`${publicPath}${mainPublicPath}/login`);
                        return false;
                    }
                }
            }
            else if (isLoginVar) {
                // for testing
                // if (isLoginVar) {
                //   if (urlTojudge === '/acct/subscription') {
                //   } else if (urlTojudge === '/' || urlTojudge === '/login') {
                //     history.push(`${publicPath}/home`);
                //     return false;
                //   }
                // } else if (urlTojudge === '/' || urlTojudge === '/home') {
                //   history.push(`${publicPath}/login`);
                //   return false;
                // }
                // history.push(landingApp.activeRule);
            }
            else if (urlTojudge !== `${mainPublicPath}/logout`) {
                // history.push(`${publicPath}${welcomeURL}`);
            }
        }
        else if (app.alias === 'partner-subscription-terms') {
            if (app.configuration.loginRequired && !isLogin()) {
                history.push(publicPath + loginURL);
                return false;
            }
        }
    }
};
exports.checkAuthInterceptor = checkAuthInterceptor;
